import React from 'react';
import { useSelector } from 'react-redux';

import { Checkbox, TableRow, TableCell } from '@unimed-fesp/components';

import TipoStatusEnum from '../../../enums/TipoStatusEnum';
import TipoPerfilUsuarioEnum from '../../../enums/TipoPerfilUsuarioEnum';

import EmptyContent from '../../molecules/EmptyContent';

const TableBody = ({ selectedUser, handleCheckUser }) => {
  const { responseUsuarioEspelho: response } = useSelector(
    (state) => state.usuario
  );

  return (
    <>
      {!(response && response.data && response.data.length > 0) ? (
        <TableRow>
          <TableCell colSpan={6}>
            <EmptyContent />
          </TableCell>
        </TableRow>
      ) : (
        <>
          {response.data.map((user) => (
            <TableRow isClickable onClick={() => handleCheckUser(user)}>
              <TableCell minWidth={18} maxWidth={20}>
                <Checkbox
                  height={18}
                  width={18}
                  onClick={() => handleCheckUser(user)}
                  checked={user.idUsuario === selectedUser?.idUsuario}
                />
              </TableCell>
              <TableCell maxWidth={300} minWidth={150}>
                {user.nome ? user.nome : '-'}
              </TableCell>
              <TableCell maxWidth={120} minWidth={150}>
                {user.email ? user.email : '-'}
              </TableCell>
              <TableCell maxWidth={100} minWidth={80}>
                {user.tipoPerfil
                  ? TipoPerfilUsuarioEnum.returnNameFormattedForName[
                      user.tipoPerfil
                    ]
                  : '-'}
              </TableCell>
              <TableCell maxWidth={90} minWidth={80}>
                {user.tipoStatus
                  ? TipoStatusEnum.returnNameFormattedForName[user.tipoStatus]
                  : '-'}
              </TableCell>
            </TableRow>
          ))}
        </>
      )}
    </>
  );
};

export default TableBody;
